import * as React from "react"
import * as _ from "lodash"

export interface ModalComponentProps {
    modalSize: string,
    children: any,
    onClickCloseHandler?: () => void,
    onClickPreventCloseHandler?: (event: any) => void,
    keepPadding?: boolean,
    className?: string
}

export const ModalComponent = (props: ModalComponentProps) => {
    let noPadding = props.keepPadding !== undefined && !props.keepPadding ? "noPadding" : "";
    let customClassName = props.className ? props.className : "";
    let modalCssClasses = `modal-content ${props.modalSize} ${noPadding} ${props.className || ""}`;
    return (
        <div className="modal-backdrop" onClick={props.onClickCloseHandler}>
            <div className="modal-container">
                <div className={modalCssClasses}>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export interface IMultiModalComponentProps {
    isActive: boolean,
    modalSize: string,
    components: Array<JSX.Element | React.FunctionComponent | React.Component>,
    className?: string
}

interface IComponentData {
    component: React.FunctionComponent | React.Component,
    active: boolean
}

export const MultiModalComponent = (props: IMultiModalComponentProps) => {
    const [active, toggleActiveState] = React.useState(props.isActive)
    const [componentsList, setComponentsList] = React.useState((props.components || []).map((comp) => {
        return { component: comp, active: true }
    }))
    if (!active) return null
    const removeComponentFromList = (idx: number) => {
        const updatedList = [...componentsList]
        updatedList.splice(idx, 1)
        setComponentsList(updatedList)
    }
    const handleComponentClose = (e: any, idx: number) => {
        e.stopPropagation()
        if (componentsList.length > 1) {
            let updatedList = [...componentsList]
            updatedList[idx].active = false
            setComponentsList(updatedList)
            setTimeout(() => {
                removeComponentFromList(idx)
            }, 300)
        } else {
            removeComponentFromList(idx)
            toggleActiveState(false)
        }
    }
    const modalCssClasses = `modal-content ${props.modalSize} ${props.className}`
    return (
        <div className={`modal-backdrop`} onClick={() => toggleActiveState(false)}>
            <div className="modal-container multi-modal">
                {
                    componentsList.map((component: IComponentData, index: number) => {
                        const activeCls = !component.active ? "disable" : ""
                        return <div className={modalCssClasses + ` ${activeCls}`}>
                            <img className={"close-icon"} src={"/images/icons/cross-grey.svg"} onClick={(e: any) => handleComponentClose(e, index)} />
                            {component.component}
                        </div>
                    })
                }
            </div>
        </div>
    )
}